import React, { useState } from 'react';
import { IoTriangle } from 'react-icons/io5';
import CohortList from './CohortList';
import PropTypes from 'prop-types';
import useModal from './useModal';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import Routes from 'utils/routes.js.erb';
import { authHeaders } from 'actions';
import { errorMessage, customMessage } from 'actions/internal';
import { connect } from 'react-redux';


const SubGroupItem = ({group, groupIdx, subgroup, subgroupIdx, onCustomMessage, onErrorMessage}) => {
  const [expanded, setExpanded] = useState(groupIdx === 0 && subgroupIdx === 0);
  const { openModal } = useModal();
  const queryClient = useQueryClient();

  const remove = useMutation({
    mutationFn: (subgroup) => {
      return axios.delete(Routes.api_dashboard_administration_organizations_destroy_subgroup_path({ subgroup_id: subgroup.id }), { headers: authHeaders() })
    },
    onSuccess: () => {
      onCustomMessage('Sub-Group deleted successfully', 'success');
      queryClient.invalidateQueries({ queryKey: ['administration', 'organization', 'groups', group.id, 'subgroups'] })
    },
    onError: (err) => {
      if (axios.isAxiosError(err)) {
        onErrorMessage(Object.values(err.response.data.errors).flat().join(', '));
      } else {
        onErrorMessage('Oops! Something went wrong. Contact support for help.');
      }
    },
  })

  return (
    <>
      <div className='row-cell'>
        <span className='cell expand level2' onClick={() => setExpanded(!expanded)}>
          <IoTriangle style={{color: 'green'}} />
          {expanded ? (<i className="fa fa-chevron-down"></i>) : (<i className="fa fa-chevron-right"></i>)}
        </span>
        <span className='cell id'>{subgroup.id}</span>
        <span className='cell name'>
          {subgroup.name}
          {!subgroup.is_na && (
            <>
              {subgroup.can_edit && (
                <a className="edit" onClick={() => openModal('subgroup', group, subgroup)}>
                  <i className="fa fa-pencil"></i>
                  &nbsp;
                  Edit
                </a>
              )}
              {subgroup.can_delete && (
                <a className="remove" onClick={() => window.confirm('Are you sure you want to delete this sub-group?') && remove.mutate(subgroup)}>
                  <i className="fa fa-trash"></i>
                  &nbsp;
                  Remove
                </a>
              )}
            </>
          )}
        </span>
      </div>
      {expanded && (<CohortList group={group} subgroup={subgroup} />)}
    </>
  );
}

SubGroupItem.propTypes = {
  group: PropTypes.object.isRequired,
  groupIdx: PropTypes.number.isRequired,
  subgroup: PropTypes.object.isRequired,
  subgroupIdx: PropTypes.number.isRequired,
  onErrorMessage: PropTypes.func.isRequired,
  onCustomMessage: PropTypes.func.isRequired,
}

const mapStateToProps = () => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return {
    onErrorMessage: (message) => {
      dispatch(errorMessage(message))
    },
    onCustomMessage: (message, type) => {
      dispatch(customMessage(message, type))
    },
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(SubGroupItem);


